export function getdata() {
	var obj = {
		formlist: [{
				prop: "test1",
				label: "省市地区代码",
				type: "select",
			},
			{
				prop: "test2",
				label: "登录方式",
				type: "select",
			},
			{
				prop: "test3",
				label: "账号",
				type: "input",
			},
			{
				prop: "test4",
				label: "密码",
				type: "input",
				ispassword: true
			},
			{
				prop: "test5",
				label: "身份类型",
				type: "select",
			},
			{
				prop: "test6",
				label: "证件号码",
				type: "input",
			},
			{
				prop: "test7",
				label: "个人用户名",
				type: "input",
			},
			{
				prop: "test8",
				label: "个人密码",
				type: "input",
				ispassword: true
			},
			{
				prop: "test9",
				label: "办税小号",
				type: "input",
			},
			{
				prop: "test10",
				label: "办税手机号",
				type: "input",
			}
		],
		formdata: {},
	}
	return obj
}
